import {
  EMPLOYEETAX_LOADING,
  GET_EMPLOYEETAX,
  GET_EMPLOYEETAX_SUCCESS,
  GET_EMPLOYEETAX_FAIL,
  ADD_EMPLOYEETAX_SUCCESS,
  ADD_EMPLOYEETAX_FAIL,
  DELETE_EMPLOYEETAX_SUCCESS,
  DELETE_EMPLOYEETAX_FAIL,
  UPDATE_EMPLOYEETAX_SUCCESS,
  UPDATE_EMPLOYEETAX_FAIL,
  EMPLOYEETAX_RESET
} from "./actionType";

const INIT_STATE = {
  employeeTaxs: [],
  error: {},
};

const EmployeeTax = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EMPLOYEETAX_SUCCESS:
      switch (action.payload.actionType) {
        case GET_EMPLOYEETAX:
          return {
            ...state,
            employeeTaxs: action.payload.data,
            isEmployeeTaxCreated: false,
            isEmployeeTaxSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_EMPLOYEETAX_FAIL:
      switch (action.payload.actionType) {
        case GET_EMPLOYEETAX_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isEmployeeTaxCreated: false,
            isEmployeeTaxSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_EMPLOYEETAX: {
      return {
        ...state,
        isEmployeeTaxCreated: false,
        loading: true,
      };
    }

    case EMPLOYEETAX_LOADING: {
      return {
        ...state,
        isEmployeeTaxCreated: false,
        loading: true,
      };
    }

    case ADD_EMPLOYEETAX_SUCCESS:
      return {
        ...state,
        isEmployeeTaxCreated: true,
        loading: false,
        employeeTaxs: [action.payload.data, ...state.employeeTaxs],
      };

    case ADD_EMPLOYEETAX_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_EMPLOYEETAX_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeTaxs: state.employeeTaxs.filter(
          employeeTax => employeeTax.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_EMPLOYEETAX_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_EMPLOYEETAX_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeTaxs: state.employeeTaxs.map(employeeTax =>
          employeeTax.id.toString() === action.payload.data.id.toString() ? { ...employeeTax, ...action.payload.data } : employeeTax
        ),
      };

    case UPDATE_EMPLOYEETAX_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case EMPLOYEETAX_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default EmployeeTax;